// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__ReVF6","modalForm":"UpgradeEpcsModal_modalForm__31j0w","modalFooter":"UpgradeEpcsModal_modalFooter__1veTC"};